<div class="tcCon">
    <div class="tjcoSize">添加菜品</div>
    <div class="ssBtn">
        <input type="text" [(ngModel)]="goods" placeholder="请输入搜索关键词">
        <button (click)="search()"><img src="assets/home_ic_fdj.png" alt=""></button>
    </div>
    <div class="ssCon">
        <div class="ssList" *ngFor="let goods of goodsList let i=index let odd=odd">
            <div>{{goods.name}}</div>
            <div>{{goods.pubDate}}</div>
            <input type="checkbox" [(ngModel)]="goods.select" (ngModelChange)="select(goods.id)">
        </div>
    </div>
    <div class="qxtjBtn">
        <button (click)="cancel()">取消</button>
        <button (click)="add()">添加</button>
    </div>
</div>